
document.documentElement.classList.add('js');
(function(){
  var btn=document.getElementById('burger'), dr=document.getElementById('drawer');
  if(!btn||!dr) return;
  btn.addEventListener('click', function(){
    var open = btn.getAttribute('aria-expanded')==='true';
    btn.setAttribute('aria-expanded', String(!open));
    dr.hidden = open;
  });
  dr.addEventListener('click', function(e){
    if(e.target.tagName==='A'){ btn.setAttribute('aria-expanded','false'); dr.hidden=true; }
  });
})();
(function(){
  var items = document.querySelectorAll('.reveal');
  function showAll(){ items.forEach(function(el){ el.classList.add('in'); }); }
  if(!('IntersectionObserver' in window)){ showAll(); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, {rootMargin:'0px 0px -8% 0px', threshold:0.05});
  items.forEach(function(el){ io.observe(el); });
  setTimeout(showAll, 2500);           // fails open
})();



/* --- turntable: works with however many frames are in the stage --- */
document.querySelectorAll('.stage').forEach(function(st){
  var frames = [].slice.call(st.querySelectorAll('img')), n = frames.length, i = 0, timer = null, still = false;
  function show(k){ i = ((k % n) + n) % n; frames.forEach(function(f, j){ f.classList.toggle('on', j === i); }); }
  var dir = 1;
  function tick(){ if (still) return; if (i + dir >= n || i + dir < 0) dir = -dir; show(i + dir); }
  function play(){ stop(); timer = setInterval(tick, 1400); }
  function stop(){ if (timer) { clearInterval(timer); timer = null; } }
  play();

  var down = false, x0 = 0, i0 = 0;
  st.addEventListener('pointerdown', function(e){
    if (still) return;
    down = true; x0 = e.clientX; i0 = i; stop();
    st.setPointerCapture(e.pointerId);
  });
  st.addEventListener('pointermove', function(e){
    if (!down) return;
    show(i0 + Math.round((e.clientX - x0) / 46));
  });
  ['pointerup','pointercancel'].forEach(function(ev){
    st.addEventListener(ev, function(){ down = false; play(); });
  });
  st.addEventListener('pointerleave', function(){ if (down) { down = false; play(); } });

  /* thumbnails: one returns to the turntable, the rest pin a still */
  var gal = st.closest('.gal'), btns = gal.querySelectorAll('.thumbs button'), pinned = null;
  btns.forEach(function(b){
    b.addEventListener('click', function(){
      btns.forEach(function(o){ o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
      if (b.dataset.view === 'spin') {
        if (pinned) { pinned.remove(); pinned = null; }
        still = false; st.classList.remove('still'); show(0); play();
        return;
      }
      stop(); still = true; st.classList.add('still');
      if (!pinned) { pinned = new Image(); pinned.className = 'on'; st.appendChild(pinned); }
      frames.forEach(function(f){ f.classList.remove('on'); });
      pinned.src = b.dataset.src; pinned.alt = b.querySelector('img').alt; pinned.classList.add('on');
    });
  });
});

/* --- quantity + basket (preview only; Shopify owns the real cart) --- */
(function(){
  var q = 1, out = document.getElementById('q-val'), bag = document.getElementById('u-bag'),
      msg = document.getElementById('added'), count = 0;
  var field = document.getElementById('q-field');
  function set(v){ q = Math.max(1, Math.min(10, v)); out.textContent = q;
    if (field) field.value = q; }
  var minus = document.getElementById('q-minus'), plus = document.getElementById('q-plus');
  if (minus) minus.addEventListener('click', function(){ set(q - 1); });
  if (plus)  plus.addEventListener('click', function(){ set(q + 1); });
  function finish(){ return document.getElementById('p-white').checked ? '18ct white gold' : '18ct yellow gold'; }
  function add(){
    count += q;
    if (bag) bag.textContent = 'Bag (' + count + ')';
    msg.textContent = q + ' × Cross Pendant, ' + finish() + ', added to your basket.';
  }
  var a = document.getElementById('add-cart'), b = document.getElementById('buy-now');
  if (a) a.addEventListener('click', add);
  if (b) b.addEventListener('click', function(){
    add(); msg.textContent = 'Checkout opens here — Shopify hosts this step on the live site.';
  });
})();



(function(){
  var f = document.getElementById('enquiry');
  if (!f) return;
  var sent = document.getElementById('sent');
  function fail(el, box, msg){
    el.setAttribute('aria-invalid','true');
    document.getElementById(box).textContent = msg;
  }
  function clear(el, box){
    el.removeAttribute('aria-invalid');
    document.getElementById(box).textContent = '';
  }
  f.addEventListener('submit', function(e){
    var name = document.getElementById('c-name'),
        mail = document.getElementById('c-email'),
        msg  = document.getElementById('c-msg'), ok = true;
    if (!name.value.trim()) { fail(name,'e-name','Please tell us your name.'); ok = false; } else clear(name,'e-name');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail.value.trim())) {
      fail(mail,'e-email','We need an address we can reply to.'); ok = false;
    } else clear(mail,'e-email');
    if (msg.value.trim().length < 10) { fail(msg,'e-msg','A line or two so we know what you need.'); ok = false; }
    else clear(msg,'e-msg');
    if (!ok) { e.preventDefault(); (document.querySelector('[aria-invalid="true"]')||name).focus(); return; }
    if (f.dataset.preview === '1') {           // preview only: fake the confirmation
      e.preventDefault();
      f.querySelector('button[type=submit]').disabled = true;
      if (sent) { sent.classList.add('on'); sent.scrollIntoView({behavior:'smooth', block:'center'}); }
    }                                          // in the theme it posts to Shopify
  });
})();
